import { BaseCamelCasedResource } from "./BasePlainResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
export class BusinessGuarantorSignerResource extends BaseCamelCasedResource {
    pk() {
        return this.customerId.toString();
    }
}
BusinessGuarantorSignerResource.urlRoot = legacyApiResourceUrl("/Signer/GetBusinessGuarantors/");
//# sourceMappingURL=BusinessGuarantorSignerResource.js.map